module.exports = __webpack_public_path__ + "static/assets/e4498aa7ddd1859b445a11f36af704f1.svg";